import '@/App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/lib/auth';
import NavBar from '@/components/NavBar';
import RequireAuth from '@/components/RequireAuth';
import LandingPage from '@/pages/LandingPage';
import LoginPage from '@/pages/LoginPage';
import SignupPage from '@/pages/SignupPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import PricingPage from '@/pages/PricingPage';
import CheckoutSuccessPage from '@/pages/CheckoutSuccessPage';
import ProManagePage from '@/pages/ProManagePage';
import InspectPage from '@/pages/InspectPage';
import WatchlistPage from '@/pages/WatchlistPage';
import SignalsPage from '@/pages/SignalsPage';
import LeaderboardPage from '@/pages/LeaderboardPage';
import BulletinPage from '@/pages/BulletinPage';
import ReportCardPublicPage from '@/pages/ReportCardPublicPage';
import AdminAttributionPage from '@/pages/AdminAttributionPage';
import { APP } from '@/constants/testIds';

function App() {
  return (
    <div data-testid={APP.root} className="caelix-scanlines min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <NavBar />
          <main className="relative z-10 pt-16">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/checkout/success" element={
                <RequireAuth><CheckoutSuccessPage /></RequireAuth>
              } />
              <Route path="/pro/manage" element={
                <RequireAuth><ProManagePage /></RequireAuth>
              } />
              <Route path="/pro/inspect" element={
                <RequireAuth><InspectPage /></RequireAuth>
              } />
              <Route path="/pro/watchlist" element={
                <RequireAuth><WatchlistPage /></RequireAuth>
              } />
              <Route path="/pro/signals" element={
                <RequireAuth><SignalsPage /></RequireAuth>
              } />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
              <Route path="/bulletin" element={<BulletinPage />} />
              <Route path="/report/:shortcode" element={<ReportCardPublicPage />} />
              <Route path="/admin/attribution" element={
                <RequireAuth><AdminAttributionPage /></RequireAuth>
              } />
              <Route path="*" element={
                <div className="max-w-md mx-auto mt-24 px-6 text-xs tracking-widest uppercase text-gray-500">
                  ROUTE_NOT_FOUND<span className="caelix-caret"></span>
                </div>
              } />
            </Routes>
          </main>
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                fontFamily: 'JetBrains Mono, monospace',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                fontSize: '11px',
                borderRadius: 0,
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
